export enum UploadState {
    uploading = 'uploading',
    ready = 'ready',
    canceled = 'canceled',
}